import "../../scss/shortcodes/lottery.scss";
import {Clock} from "../components/calendarCountdown";
import {StartFireworks, reStartFireworks} from "../components/fireworks";

const icon_height_desktop = 110,
    icon_height_mobile = 58,
    num_icons = 9,
    time_per_icon = 100,
	loadingHTML = '<div class="d-block position-relative" style="height: 100px;"><div class="position-absolute" style="top:0;left:0;width:100%;height:100%;background:#3c3c3c8c;z-index:2"><div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:#333;font-size:2rem"><div class="loader"><div></div><div></div></div></div></div></div>';
let winner = 0;
let shownWinner = false;
let winners = [];
let delayInSeconds = 0;
/** 
 * Roll one reel
 */
const delay = t => new Promise(resolve => setTimeout(resolve, t));

const createClone = (reel, offset = 0) => {
    
	let nameElement = reel.querySelector('.winner');

	return new Promise((resolve, reject) => {
		let cloneWinner = nameElement.cloneNode(true);
		cloneWinner.classList.remove('winner-main');
		cloneWinner.classList.add('winner-clone');
		cloneWinner.style.top = `0px`;
		reel.appendChild( cloneWinner );
		setTimeout(() => {
			resolve(true);
		}, 500);
	});
	
};

const roll = (reel, offset = 0) => {
    
    let documentWidth = document.body.clientWidth
    let icon_height = (documentWidth < 992 ? icon_height_mobile : icon_height_desktop);
	// Minimum of 2 + the reel offset rounds
	const delta = (offset + 2) * num_icons + Math.round(Math.random() * num_icons); 
	// Return promise so we can wait for all reels to finish
	return new Promise((resolve, reject) => {
		
		const style = getComputedStyle(reel),
        // Current background position
        backgroundPositionY = parseFloat(style["background-position-y"]),
        // Target background position
        targetBackgroundPositionY = backgroundPositionY + delta * icon_height,
        // Normalized background position, for reset
        normTargetBackgroundPositionY = targetBackgroundPositionY%(num_icons * icon_height),
        animationTime = (8 + 1 * delta) * time_per_icon;
        
        let nameElement = reel.querySelector('.winner-main');
        nameElement.style.top = `-${targetBackgroundPositionY}px`;

        let nameInnerElement = nameElement.querySelector('.winner-name');
        if(nameInnerElement) nameInnerElement.innerHTML = winners[winner];
        
		let nameCloneElement = reel.querySelector('.winner-clone');
		
		// Delay animation with timeout, for some reason a delay in the animation property causes stutter
		setTimeout(() => { 
			// Set transition properties ==> https://cubic-bezier.com/#.41,-0.01,.63,1.09
			reel.style.webkitTransition = `background-position-y ${animationTime}ms cubic-bezier(.41,-0.01,.63,1.09)`;
			reel.style.transition = `background-position-y ${animationTime}ms cubic-bezier(.41,-0.01,.63,1.09)`;
			// Set background position
			reel.style.backgroundPositionY = `${targetBackgroundPositionY}px`;

			if(nameCloneElement){
				nameCloneElement.style.webkitTransition = `top ${animationTime}ms cubic-bezier(.41,-0.01,.63,1.09)`;
				nameCloneElement.style.transition = `top ${animationTime}ms cubic-bezier(.41,-0.01,.63,1.09)`;
				nameCloneElement.style.top = `${targetBackgroundPositionY}px`;
			}

            nameElement.style.webkitTransition = `top ${animationTime}ms cubic-bezier(.41,-0.01,.63,1.09)`;
			nameElement.style.transition = `top ${animationTime}ms cubic-bezier(.41,-0.01,.63,1.09)`;
            nameElement.style.top = `0px`;

            //console.log(offset+ 'reel transition for: '+animationTime+' and '+targetBackgroundPositionY);
		}, offset * 150);
		
		// After animation
		setTimeout(() => {
			// Reset position, so that it doesn't get higher without limit
			reel.style.webkitTransition = `none`;
			reel.style.transition = `none`;
			reel.style.backgroundPositionY = `${normTargetBackgroundPositionY}px`;

			nameElement.style.webkitTransition = `none`;
            nameElement.style.transition = `none`;
			nameElement.style.top = `0px`;

			if(nameCloneElement){
				nameCloneElement.remove();
			}
			
			// Resolve this promise
			resolve(true);
            //console.log(offset+ 'reel stopped');
		}, (8 + 1 * delta) * time_per_icon + offset * 150);
		
	});
};

/**
 * Roll all reels, when promise resolves roll again
 */

function rollAll(id) {
	const lotteryContainer = document.getElementById(id);
	
	const reelsList = lotteryContainer.querySelectorAll('.slots > .reel');
	let winnersContent = lotteryContainer.querySelector('.slots-winners');

	Promise
		// Activate each reel, must convert NodeList to Array for this with spread operator
		.all( [...reelsList].map((reel, i) => roll(reel, i)) )	
		// When all reels done animating (all promises solve)
		.then(() => {
			let winnerElement = winnersContent.children.item(winner);
			winnerElement.querySelector('.prize-winner-name').innerHTML = winners[winner];
			setTimeout(() => {
				winnerElement.classList.add('shownPrize');
			},100);
			if(!shownWinner){
				new StartFireworks(id);
				shownWinner = true;
			}else{
				new reStartFireworks();
			}
			winner++;
            if(winner < winners.length){
				//console.log('more winners');
				delay(delayInSeconds * 1000).then(() => rollWinners(id));
            }else{
				//hide froytakia
				delay(5 * 1000).then(() => {
					const lotteryContainer = document.getElementById(id);
					const slotsElement = lotteryContainer.querySelector('.slots-to-remove');
					slotsElement.style.height = "0";
					setTimeout(() => { 
						slotsElement.remove();
					},1200);
				});	
			}
		});
};

function moveHandle(id) {
	const lotteryContainer = document.getElementById(id);
	const slotsHandle = lotteryContainer.querySelector('.slots-handle');
	slotsHandle.classList.add('active');
	setTimeout(() => { 
		slotsHandle.classList.remove('active');
		rollAll(id);
	},500);

}

function rollWinners(id) {
	const lotteryContainer = document.getElementById(id);
	const slotsHandle = lotteryContainer.querySelector('.slots-handle');
	slotsHandle.classList.add('active');
	const reelsList = lotteryContainer.querySelectorAll('.slots > .reel');
	Promise
		.all( [...reelsList].map((reel, i) => createClone(reel, i)) )	
		.then(() => {
			slotsHandle.classList.remove('active');
			rollAll(id);
		});
};

function fetchLotteryData(id) {

	const lotteryContainer = document.getElementById(id);
	let ajaxContent = lotteryContainer.querySelector('.ajax-content');
	let lotteryDate = lotteryContainer.dataset.lotterydate;
	let ajaxUrl = lotteryContainer.dataset.url;
	let headers = {
        "Content-Type": "text/html",
        "X-Requested-With": "XMLHttpRequest"
    };
	fetch(ajaxUrl, {
		method: "GET",
		headers: headers,
	})
	.then(
		response => response.json()
	)
	.then(json => {
		if(json.showContent){
			//console.log(json);
			ajaxContent.innerHTML = json.content;
			winners = json.winners;
			delayInSeconds = json.lotteryDelay;
			
			let timePassed = Date.parse(new Date()) - Date.parse(lotteryDate) - 2000;
			let winnerLotteryTime = (1 + parseInt(delayInSeconds)) * 1000;
			let winnersToShow = Math.floor(timePassed / winnerLotteryTime);
			//console.log(timePassed+' - '+winnerLotteryTime+' - '+winnersToShow);
			if(winnersToShow > winners.length){
				winnersToShow = winners.length;
			}
			if(winnersToShow > 0){
				winner = winnersToShow;
				//show the winners based on time
				let winnersContent = lotteryContainer.querySelector('.slots-winners');
				for (let i = 0; i < winnersToShow; i++) {
					winnersContent.children.item(i).querySelector('.prize-winner-name').innerHTML = winners[i];
					winnersContent.children.item(i).classList.add('shownPrize');
				}
			}
			if(winnersToShow < winners.length){
				setTimeout(() => { 
					moveHandle(id)
				}, 2000);
			}else{
				const slotsElement = lotteryContainer.querySelector('.slots-to-remove');
				slotsElement.style.height = "0";
				setTimeout(() => { 
					slotsElement.remove();
				},1200);
			}
		}else{
			ajaxContent.innerHTML = loadingHTML;
			//set timout to 1500ms + a random value between 500ms - 1500ms -> so timeout occurs between 2000sec - 3000ms -> gives time to CDN to cache so that not all requests hit at the same time
			setTimeout(() => { 
				fetchLotteryData(id)
			},(1500 + Math.round(500 + Math.random() * 1000)));
		}
	})
	.catch(function (error) {
		console.log(error);
	});
};

const siteUrl = window.location.origin;
export async function getServertime() {
    const response = await fetch(siteUrl + '/getServerTime', {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
			"Cache-Control": "no-cache"
        },
    });

    if (response.status !== 200) {
        throw new Error("cannot fetch server time");
    }

    let responseData = await response.json();
    return responseData;
}

window.setUpLottery = function setUpLottery() {
	
	let lotteryContainer = document.querySelector('.mission-lottery');
	if (lotteryContainer){
		let slotsContainer = lotteryContainer.querySelector('.slots-container');
		let ajaxContent = lotteryContainer.querySelector('.ajax-content');
		let expireDate = lotteryContainer.dataset.expiredate;
		let lotteryDate = lotteryContainer.dataset.lotterydate;
		let currentDate = lotteryContainer.dataset.currentdate;
		let containerId = lotteryContainer.id;
		
		let formattedExpireDate = new Date(
			Date.parse(expireDate)
		);
		let formattedCurrentDate = new Date(
			Date.parse(currentDate)
		);
		//maximum datetime based on CDN 3min cache
		let formattedCurrenMaxDate = new Date(
			Date.parse(currentDate) + 3 * 60 * 1000
		);
		//if formattedExpireDate > formattedCurrenMaxDate -> the mission has not expired, so do nothing
		if(formattedExpireDate > formattedCurrenMaxDate){
			return;
		}
		let formattedLotteryDate = new Date(
			Date.parse(lotteryDate)
		);
		//lottery has been completed -> show lottery
		if(formattedLotteryDate < formattedCurrentDate){
			slotsContainer.classList.remove('d-none');
			ajaxContent.innerHTML = loadingHTML;
			setTimeout(() => { 
				fetchLotteryData(containerId);
			},(1000 + Math.round(300 + Math.random() * 1000)));
			return;
		}
		getServertime().then((responseData) => {
			let serverTimestamp = Date.parse(responseData.serverTime);
			let formattedServerTime = new Date(serverTimestamp);
			let now = new Date();
			if(formattedExpireDate > formattedServerTime){
				//mission not expired -> do nothing.
			}else if(formattedLotteryDate > formattedServerTime){
				//mission expired -> waiting for lottery
				//set correct Clock time: now + (formattedLotteryDate - serverDateTime)
				let remainingServerTime = Date.parse(lotteryDate) - serverTimestamp;
				formattedLotteryDate = new Date(
					Date.parse(now) + remainingServerTime
				);
				slotsContainer.classList.remove('d-none');
				let c = new Clock(formattedLotteryDate, function(){
					//show lottery
					ajaxContent.innerHTML = loadingHTML;
					setTimeout(() => { 
						fetchLotteryData(containerId);
					},(1000 + Math.round(300 + Math.random() * 1000)));
				});
				ajaxContent.innerHTML='';
				ajaxContent.appendChild(c.el);
			}else{
				//show lottery
				slotsContainer.classList.remove('d-none');
				ajaxContent.innerHTML = loadingHTML;
				setTimeout(() => { 
					fetchLotteryData(containerId);
				},(1000 + Math.round(300 + Math.random() * 1000)));
			}
		});
	}
}

setUpLottery();